import { Button, Modal } from '@dev-spendesk/grapes';
import { type Dispatch, type SetStateAction } from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { type IntegrationReverseChargeAccount } from 'src/core/modules/bookkeep/settings/accounting';

import { type ModalState } from './chift/ChiftReverseChargeSetSection';

type Props = {
  onDelete: (taxAccount: IntegrationReverseChargeAccount) => Promise<void>;
  formState: ModalState;
  setFormState: Dispatch<SetStateAction<ModalState>>;
};

export const ReverseChargeDeleteModal = ({
  onDelete,
  formState,
  setFormState,
}: Props) => {
  const { t } = useTranslation('global');

  return (
    <Modal
      title={
        formState.kind === 'confirmDeleteReverseCharge'
          ? t(
              'bookkeep.integrations.settings.reverseChargeAccountsTable.confirmDeleteTaxAccountTitle',
              { accountName: formState.name },
            )
          : ''
      }
      subtitle={t(
        'bookkeep.integrations.settings.reverseChargeAccountsTable.confirmSendBackToPrepareSubtitle',
      )}
      isOpen={formState.kind === 'confirmDeleteReverseCharge'}
      iconVariant="alert"
      iconName="trash"
      actions={[
        <Button
          key="cancel"
          onClick={() => setFormState({ kind: 'closed' })}
          text={t('misc.cancel')}
          variant="secondaryNeutral"
        />,
        <Button
          key="yes"
          onClick={() => {
            if (formState.kind === 'confirmDeleteReverseCharge') {
              onDelete({
                id: formState.id,
                name: formState.name,
                codeDebit: formState.codeDebit,
                codeCredit: formState.codeCredit,
                type: 'reverseCharge',
              });
            }

            setFormState({ kind: 'closed' });
          }}
          text={t(
            'bookkeep.integrations.settings.reverseChargeAccountsTable.confirmDeletion',
          )}
          variant="primaryAlert"
        />,
      ]}
    />
  );
};
